import FilterDetailedButton from './FilterDetailedButton';

export default FilterDetailedButton;
